"use client";

import { useState } from "react";
import { Typography } from "../typography";

export interface FAQResponse {
  id: number;
  question: string;
  answer: string;
}

interface Props {
  data: FAQResponse[];
}

const Faq = ({ data }: Props) => {
  const [openIndexes, setOpenIndexes] = useState<number[]>([]);

  const toggleAccordion = (id: number) => {
    if (openIndexes.includes(id)) {
      setOpenIndexes(openIndexes.filter((i) => i !== id));
    } else {
      setOpenIndexes([...openIndexes, id]);
    }
  };

  return (
    <div className="container divide-y  mx-auto pb-6 px-4">
      <div className="flex flex-col md:flex-row justify-between mt-2 items-center">
        <div className="w-full">
          <Typography
            tag="h1"
            className="text-center lg:text-left text-[2em] my-0 pb-10 pt-4"
          >
            FAQs
          </Typography>
        </div>
      </div>

      {data.map((item) => (
        <div key={item.id}>
          <button
            type="button"
            className="w-full text-base font-semibold py-5 text-gray-800 flex justify-between items-center"
            onClick={() => toggleAccordion(item.id)}
            aria-expanded={openIndexes.includes(item.id)}
            aria-controls={`accordion-arrow-icon-body-${item.id}`}
          >
            <span className="my-4 text-xl text-left">{item.question}</span>
            <svg
              width="23px"
              height="23px"
              className="shrink-0 mx-4"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d={
                  openIndexes.includes(item.id)
                    ? "M6 12L18 12"
                    : "M4 12H20M12 4V20"
                }
                stroke="#04919D"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
          <div
            className={`pb-2 -mt-3 ${
              openIndexes.includes(item.id) ? "block" : "hidden"
            }`}
          >
            <Typography className="text-md text-gray-800 mt-0" tag="p">
              {item.answer}
            </Typography>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Faq;

// or
// DESIGN ________2

// "use client";

// import Image from "next/image";
// import { useState } from "react";
// import { Typography } from "../typography";

// export interface FAQResponse {
//   id: number;
//   question: string;
//   answer: string;
// }
// interface Props {
//   data: FAQResponse[];
// }
// const Faq = ({ data }: Props) => {
//   const [openIndexes, setOpenIndexes] = useState<number[]>([]);
//   const toggleAccordion = (id: number) => {
//     if (openIndexes.includes(id)) {
//       setOpenIndexes(openIndexes.filter((i) => i !== id));
//     } else {
//       setOpenIndexes([...openIndexes, id]);
//     }
//   };
//   return (
//     <div className="container  mx-auto px-4 mb-5">
//       <div className="flex flex-col md:flex-row justify-between my-2   items-center">
//         <div className="w-full ">
//           <Typography tag="h1" className="text-center lg:text-left">
//             FAQs
//           </Typography>
//         </div>
//       </div>
//       {data.map((item) => (
//         <div
//           className="container mx-auto bg-[#ECFAFC] my-5 shadow-lg rounded-lg"
//           key={item.id}
//         >
//           <h2 id={`accordion-arrow-icon-heading-${item.id}`}>
//             <button
//               type="button"
//               className="flex items-center justify-between w-full p-5   gap-3"
//               onClick={() => toggleAccordion(item.id)}
//               aria-expanded={openIndexes.includes(item.id)}
//               aria-controls={`accordion-arrow-icon-body-${item.id}`}
//             >
//               <span className="text-left">{item.question}</span>
//               {/* <svg
//                 data-accordion-icon
//                 className={`w-3 h-3 ${openIndexes.includes(item.id) ? "" : "rotate-180"} shrink-0`}
//                 aria-hidden="true"
//                 xmlns="http://www.w3.org/2000/svg"
//                 fill="red"
//                 viewBox="0 0 10 6"
//               >
//                 <path
//                   stroke="currentColor"
//                   strokeLinecap="round"
//                   strokeLinejoin="round"
//                   strokeWidth="2"
//                   d="M9 5 5 1 1 5"
//                 />
//               </svg> */}
//               {openIndexes.includes(item.id) ? (
//                 <Image src="/img/dash.svg" height={20} width={20} alt="plus" />
//               ) : (
//                 <Image
//                   src="/img/plus-lg.svg"
//                   height={20}
//                   width={20}
//                   alt="plus"
//                 />
//               )}
//             </button>
//           </h2>
//           <div
//             id={`accordion-arrow-icon-body-${item.id}`}
//             className={`${openIndexes.includes(item.id) ? "" : "hidden"}`}
//             aria-labelledby={`accordion-arrow-icon-heading-${item.id}`}
//           >
//             <div className="mx-5 my-3 py-3">{item.answer}</div>
//           </div>
//         </div>
//       ))}
//     </div>
//   );
// };
// export default Faq;
